// --- VIEW IMPORTS ---
import Dashboard from "views/Dashboard/Dashboard.js";
import SearchResultsPage from "views/Dashboard/SearchResultsPage.js";
import Favorites from "views/Dashboard/Favorites.js";
import Admirers from "views/Dashboard/Admirers";
import Blocked from "views/Dashboard/Blocked";
import MyProfile from "views/Dashboard/MyProfile.js";
import ChatList from "./views/Components/Chat/ChatList";
import CreateAffiliateMarketer from "views/Dashboard/CreateAffiliateMarketer.js";
import CreateTLMarketer from "views/Dashboard/CreateTLMarketer.js";
import MarketerSettings from "views/Dashboard/MarketerSettings.js";
import DownlinesList from "views/Dashboard/DownlinesList.js";
import AccountInterface from "views/Dashboard/AccountInterface.js";
import Announcement from "views/Dashboard/Announcement";
import UsersList from "views/Dashboard/UsersList";
import ProfilePhotos from "views/Dashboard/ProfilePhotos";
import PhotoGallery from "views/Dashboard/PhotoGallery";
import VerifyEmailPage from "views/Pages/VerifyEmailPage";
import LoginPage from "views/Pages/LoginPage.js";
import RegisterPage from "views/Pages/RegisterPage.js";
import RegisterSuccessPage from "views/Pages/RegisterSuccessPage.js";
import PaymentResultPage from "views/Pages/PaymentResultPage.js";
import WhyUs from "views/Pages/WhyUs";
import ChangePassword from "views/Dashboard/ChangePassword";
import ResetPassword from "views/Pages/ResetPassword";
import ChatWindow from "views/Components/Chat/ChatWindow";
import RegularForms from "views/Forms/RegularForms.js";
import TermsOfUse from "views/Pages/TermsOfUse";
import PrivacyPolicy from "views/Pages/PrivacyPolicy";
import AffiliatePolicy from "views/Pages/AffiliatePolicy";

// --- MUI ICON IMPORTS ---
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import PersonSearchOutlinedIcon from "@mui/icons-material/PersonSearchOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import PhotoCameraFrontOutlinedIcon from "@mui/icons-material/PhotoCameraFrontOutlined";
import PhotoLibraryOutlinedIcon from "@mui/icons-material/PhotoLibraryOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import VolunteerActivismOutlinedIcon from "@mui/icons-material/VolunteerActivismOutlined";
import GroupIcon from "@mui/icons-material/Group";

var dashRoutes = [
  /* --- AUTH & BACKGROUND ROUTES (Not in Sidebar) --- */
  {
    path: "/verify-email",
    component: VerifyEmailPage,
    layout: "/auth",
    showInSidebar: false,
  },
  {
    path: "/login-page",
    component: LoginPage,
    layout: "/auth",
    showInSidebar: false,
  },
  {
    path: "/register-page",
    component: RegisterPage,
    layout: "/auth",
    showInSidebar: false,
  },
  {
    path: "/register-success",
    component: RegisterSuccessPage,
    layout: "/auth",
    showInSidebar: false,
  },
  {
    path: "/payment/:result",
    component: PaymentResultPage,
    layout: "/auth",
    showInSidebar: false,
  },
  {
    path: "/reset-password",
    component: ResetPassword,
    layout: "/auth",
    showInSidebar: false,
  },
  { path: "/why-us", component: WhyUs, layout: "/auth", showInSidebar: false },
  {
    path: "/terms-of-use",
    component: TermsOfUse,
    layout: "/auth",
    showInSidebar: false,
  },
  {
    path: "/privacy-policy",
    component: PrivacyPolicy,
    layout: "/auth",
    showInSidebar: false,
  },
  {
    path: "/affiliate-policy",
    component: AffiliatePolicy,
    layout: "/auth",
    showInSidebar: false,
  },
  {
    path: "/change-password",
    component: ChangePassword,
    layout: "/singles",
    showInSidebar: false,
  },
  {
    path: "/chat-window/:id",
    component: ChatWindow,
    layout: "/singles",
    showInSidebar: false,
  },
  {
    path: "/account-interface/:userId",
    component: AccountInterface,
    layout: "/singles",
    showInSidebar: false,
  },
  {
    path: "/my-profile/:userId/:section?",
    component: MyProfile,
    layout: "/singles",
    showInSidebar: false,
  },

  /* --- ADMINISTRATION SECTION (NOW FIRST) --- */
  {
    collapse: true,
    name: "Administration",
    icon: AdminPanelSettingsOutlinedIcon,
    state: "adminCollapse",
    showInSidebar: true,
    views: [
      {
        path: "/system-users",
        name: "Manage Users",
        mini: "MU",
        icon: ManageAccountsOutlinedIcon,
        component: UsersList,
        layout: "/singles",
        showInSidebar: true,
      },
      {
        path: "/manage-profile-photos",
        name: "Profile Photos",
        mini: "PP",
        icon: PhotoCameraFrontOutlinedIcon,
        component: ProfilePhotos,
        layout: "/singles",
        showInSidebar: true,
      },
      {
        path: "/manage-photos",
        name: "Gallery Photos",
        mini: "GP",
        icon: PhotoLibraryOutlinedIcon,
        component: PhotoGallery,
        layout: "/singles",
        showInSidebar: true,
      },
      {
        path: "/announcements",
        name: "Announcements",
        mini: "AN",
        icon: CampaignOutlinedIcon,
        component: Announcement,
        layout: "/singles",
        showInSidebar: true,
      },
    ],
  },

  /* --- MAIN APP NAVIGATION --- */
  {
    path: "/dashboard",
    name: "All Singles",
    icon: PeopleOutlinedIcon,
    component: Dashboard,
    layout: "/singles",
    showInSidebar: true,
  },
  {
    path: "/marketer-profile/:userId",
    name: "Marketer Settings",
    rtlName: "Marketer Settings",
    icon: GroupIcon,
    component: MarketerSettings,
    layout: "/singles",
    showInSidebar: false,
  },
  {
    path: "/downlines",
    name: "Downlines",
    rtlName: "Downlines",
    icon: GroupIcon,
    component: DownlinesList,
    layout: "/singles",
    showInSidebar: false,
  },
  {
    path: "/create-affiliate-marketer",
    name: "Create Affiliate Marketer",
    rtlName: "Create Affiliate Marketer",
    icon: GroupIcon,
    component: CreateAffiliateMarketer,
    layout: "/singles",
    showInSidebar: false,
  },
  {
    path: "/create-tl-marketer",
    name: "Create TL Marketer",
    rtlName: "Create TL Marketer",
    icon: GroupIcon,
    component: CreateTLMarketer,
    layout: "/singles",
    showInSidebar: false,
  },
  {
    path: "/chat/",
    name: "Messages",
    icon: ChatOutlinedIcon,
    component: ChatList,
    layout: "/singles",
    showInSidebar: true,
  },
  {
    path: "/admirers",
    name: "Liked Me",
    icon: VolunteerActivismOutlinedIcon,
    component: Admirers,
    layout: "/singles",
    showInSidebar: true,
  },
  {
    path: "/favorites",
    name: "My Favorites",
    icon: FavoriteBorderOutlinedIcon,
    component: Favorites,
    layout: "/singles",
    showInSidebar: true,
  },
  {
    path: "/search-results",
    name: "Search Results",
    icon: PersonSearchOutlinedIcon,
    component: SearchResultsPage,
    layout: "/singles",
    showInSidebar: true,
  },
  {
    path: "/blocked",
    name: "Blocked",
    icon: BlockOutlinedIcon,
    component: Blocked,
    layout: "/singles",
    showInSidebar: true,
  },

  /* --- HELP SECTION (UNCHANGED & COMMENTED) --- */
  //   {
  //     collapse: true,
  //     name: "Help & Support",
  //     icon: HelpOutlineIcon,
  //     state: "helpSupportCollapse",
  //     showInSidebar: true,
  //     views: [
  //       {
  //         path: "/help-desk",
  //         name: "Help Desk",
  //         mini: "HD",
  //         icon: ContactMailOutlinedIcon,
  //         component: RegularForms,
  //         layout: "/singles",
  //         showInSidebar: true,
  //       },
  //       {
  //         path: "/user-manual",
  //         name: "User Manual",
  //         mini: "UM",
  //         icon: MenuBookOutlinedIcon,
  //         component: RegularForms,
  //         layout: "/singles",
  //         showInSidebar: true,
  //       },
  //     ],
  //   },
];

export default dashRoutes;
